import React from 'react';
import Icon from '../../common/Icons';
import { NURSE_PASSAGE_SECTIONS } from './nursePassageSections';

/** Fil conducteur du passage infirmerie — une rubrique visible à la fois. */
export default function NursePassageStepper({
  activeStep = 'acts',
  completedSteps = [],
  onStepClick,
  sections = NURSE_PASSAGE_SECTIONS
}) {
  const completed = new Set(completedSteps);

  return (
    <nav className="nr-passage-stepper nr-no-print" aria-label="Rubriques du passage" role="tablist">
      <ol className="nr-passage-stepper__list">
        {sections.map((section) => {
          const isActive = activeStep === section.id;
          const isDone = completed.has(section.id);
          const btnClass = [
            'nr-passage-stepper__btn',
            isActive ? 'is-active' : '',
            isDone ? 'is-done' : ''
          ]
            .filter(Boolean)
            .join(' ');

          return (
            <li key={section.id} className="nr-passage-stepper__item">
              <button
                type="button"
                id={`nr-step-tab-${section.id}`}
                className={btnClass}
                onClick={() => onStepClick?.(section.id)}
                aria-current={isActive ? 'page' : undefined}
                role="tab"
                aria-selected={isActive}
              >
                <span className="nr-passage-stepper__icon-wrap" aria-hidden>
                  <Icon name={section.icon} size={16} className="nr-passage-stepper__icon" />
                  {isDone ? (
                    <Icon name="check" size={12} className="nr-passage-stepper__done" />
                  ) : null}
                </span>
                <span className="nr-passage-stepper__label">{section.label}</span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
